/**
 * Handles DOM focus change when Enter key is pressed
 * Moves focus to the same cell type in the next row
 * @param {string|number} rowId - Current row identifier
 * @param {string|number} timeSlotId - Time slot identifier
 * @param {string} type - Cell type (forecast, stock, produced)
 * @param {Function} onFocusChange - Focus change callback
 * @param {Array} sortedVisibleRows - Array of visible rows
 * @param {string} rowIdField - Field name for row ID ('originalProductId' or 'originalRecipeId')
 */
export const handleDOMFocusChangeOnEnterKeyPress = (
  rowId,
  timeSlotId,
  type,
  onFocusChange,
  sortedVisibleRows,
  rowIdField = 'originalProductId',
) => {
  const nextRow = sortedVisibleRows.reduce((acc, row, index) => {
    if (row[rowIdField] === rowId) {
      acc = sortedVisibleRows[index + 1] || null;
    }

    return acc;
  }, null);

  let nextFocusId = `${nextRow?.[rowIdField]}-${timeSlotId}-${type}`;

  if (!nextRow) {
    nextFocusId = `${sortedVisibleRows[0][rowIdField]}-${timeSlotId}-${type}`;
  }

  // Find and focus the next input element in the DOM
  const nextInput = document.querySelector(`input[data-focus-id="${nextFocusId}"]`);

  if (nextInput) {
    nextInput.select();
    nextInput.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    onFocusChange(nextFocusId);
  }
};
